import classnames from 'classnames'
import styles from './styles.module.scss'

const ToggleSwitch = ({ checked, onChange, id, className, ...inputProps }) => (
    <div className={className}>
        <input
            type="checkbox"
            id={`toggle-input-${id}`}
            className={styles.toggleInput}
            checked={checked}
            onChange={() => onChange(!checked)}
            {...inputProps}
        />
        <label
            htmlFor={`toggle-input-${id}`}
            className={classnames(styles.sliderContainer, { [styles.checked]: !!checked })}>
            <div className={classnames(styles.slider, { [styles.checked]: !!checked })} />
        </label>
    </div>
)

export default ToggleSwitch
